import { Component, input, Input, InputSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import moment from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
})
export class DatePickerComponent {
  label: InputSignal<string> = input<string>();

  placeholder: InputSignal<string> = input<string>();

  formControlRef: InputSignal<FormControl> = input<FormControl>();

  email: InputSignal<boolean> = input<boolean>();

  required: InputSignal<boolean> = input<boolean>();

  min: InputSignal<Date> = input<Date>();

  max: InputSignal<Date> = input<Date>();

  weekFilter: InputSignal<boolean> = input<boolean>(false);

  appearance: MatFormFieldAppearance = 'outline';

  dateFilter: (date: moment.Moment) => boolean = (date: moment.Moment) => {
    if (!this.weekFilter) {
      return true;
    }

    if (!date) {
      return false;
    }

    const day = date.toDate().getDay();
    return day !== 0 && day !== 6;
  };
}
